import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Search } from 'lucide-react';
import { navigationMenu } from '../mockData';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import LanguageSelector from './LanguageSelector';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_multi-lingua-3/artifacts/g3cckf4v_Asset%201%404x.png"
              alt="Elerein"
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden lg:flex items-center space-x-4">
            {navigationMenu.map((item, index) => (
              <div
                key={index}
                className="relative"
              >
                {item.submenu ? (
                  <>
                    <button 
                      onClick={() => setActiveDropdown(activeDropdown === index ? null : index)}
                      className="flex items-center space-x-1 text-gray-700 hover:text-sky-500 transition-colors font-medium py-3 px-4 rounded-lg hover:bg-sky-50"
                    >
                      <span>{t(item.titleKey)}</span>
                      <ChevronDown className={`w-4 h-4 transition-transform ${activeDropdown === index ? 'rotate-180' : ''}`} />
                    </button>
                    {activeDropdown === index && (
                      <>
                        <div 
                          className="fixed inset-0 z-10" 
                          onClick={() => setActiveDropdown(null)}
                        ></div>
                        <div className="absolute top-full left-0 mt-1 bg-white shadow-xl rounded-lg py-2 min-w-[220px] z-20 animate-in fade-in slide-in-from-top-2 duration-200 border border-gray-100">
                          {item.submenu.map((subitem, subindex) => (
                            <Link
                              key={subindex}
                              to={subitem.link}
                              onClick={() => setActiveDropdown(null)}
                              className="block px-5 py-3 text-gray-700 hover:bg-sky-50 hover:text-sky-500 transition-colors font-medium"
                            >
                              {t(subitem.titleKey)}
                            </Link>
                          ))}
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <Link
                    to={item.link}
                    className="text-gray-700 hover:text-sky-500 transition-colors font-medium py-3 px-4 rounded-lg hover:bg-sky-50 block"
                  >
                    {t(item.titleKey)}
                  </Link>
                )}
              </div>
            ))}
          </div>

          {/* Language Selector, Search & Mobile Menu */}
          <div className="flex items-center space-x-2">
            <LanguageSelector />
            <button className="p-2 text-gray-700 hover:text-sky-500 transition-colors">
              <Search className="w-5 h-5" />
            </button>
            <button
              className="lg:hidden p-2 text-gray-700 hover:text-sky-500 transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 animate-in slide-in-from-top duration-300">
          <div className="px-4 py-4 space-y-2">
            {navigationMenu.map((item, index) => (
              <div key={index}>
                {item.submenu ? (
                  <div>
                    <div className="font-medium text-gray-900 py-2">{t(item.titleKey)}</div>
                    <div className="pl-4 space-y-2">
                      {item.submenu.map((subitem, subindex) => (
                        <Link
                          key={subindex}
                          to={subitem.link}
                          className="block py-2 text-gray-600 hover:text-sky-500 transition-colors"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          {t(subitem.titleKey)}
                        </Link>
                      ))}
                    </div>
                  </div>
                ) : (
                  <Link
                    to={item.link}
                    className="block py-2 font-medium text-gray-900 hover:text-sky-500 transition-colors"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {t(item.titleKey)}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
